import React, { useState } from "react";

const SalaryAndAssetsCard = () => {
  const [month, setMonth] = useState("June");
  const [assets, setAssets] = useState([
    { id: 1, serial: "Item 1", product: "Laptop", issueDate: "10/05/2025" },
  ]);

  const handleAddItem = () => {
    const newItem = {
      id: assets.length + 1,
      serial: `Item ${assets.length + 1}`,
      product: "Laptop",
      issueDate: "10/05/2025",
    };
    setAssets([...assets, newItem]);
  };

  return (
    <div className="max-w-4xl mx-auto mt-10 p-6 bg-white shadow rounded-md">
      {/* Header */}
      <div className="flex items-center gap-4 border-b pb-4 mb-4">
        <img
          src="https://via.placeholder.com/64"
          alt="Profile"
          className="w-16 h-16 rounded-full object-cover"
        />
        <div>
          <h2 className="text-lg font-semibold">Your name</h2>
          <p className="text-gray-500">yourname@gmail.com</p>
        </div>
      </div>

      {/* Content Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Salary Section */}
        <div>
          <h3 className="text-md font-semibold mb-2">Salary & Perk</h3>
          <div className="mb-3">
            <label className="block text-sm font-medium">Month</label>
            <select
              className="w-full border rounded px-2 py-1 mt-1"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            >
              {[
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ].map((m) => (
                <option key={m} value={m}>
                  {m}
                </option>
              ))}
            </select>
          </div>

          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span>Approval Date</span>
              <span>10/05/2025</span>
            </div>
            <div className="flex justify-between">
              <span>Basic Pay</span>
              <span>25000</span>
            </div>
            <div className="flex justify-between">
              <span>Allowance</span>
              <span>2000</span>
            </div>
            <div className="flex justify-between">
              <span>Arrears</span>
              <span>00</span>
            </div>
            <div className="flex justify-between">
              <span>Perk</span>
              <span>1000</span>
            </div>
            <div className="flex justify-between font-semibold">
              <span>Total</span>
              <span>28000</span>
            </div>
          </div>
        </div>

        {/* Asset Section */}
        <div>
          <h3 className="text-md font-semibold mb-2">Assets Details</h3>
          <div className="space-y-3">
            {assets.map((item) => (
              <div key={item.id} className="grid grid-cols-3 gap-4 text-sm">
                <div>
                  <label className="block font-medium">Serial No.</label>
                  <input
                    value={item.serial}
                    readOnly
                    className="w-full border rounded px-2 py-1"
                  />
                </div>
                <div>
                  <label className="block font-medium">Product</label>
                  <select className="w-full border rounded px-2 py-1">
                    <option>Laptop</option>
                    <option>Monitor</option>
                    <option>Keyboard</option>
                  </select>
                </div>
                <div>
                  <label className="block font-medium">Issue Date</label>
                  <input
                    type="date"
                    value={item.issueDate}
                    readOnly
                    className="w-full border rounded px-2 py-1"
                  />
                </div>
              </div>
            ))}

            <button
              onClick={handleAddItem}
              className="flex items-center justify-center gap-2 bg-[#2C4E86] text-white px-4 py-2 rounded text-sm"
            >
              <span>＋ Add Item</span>
            </button>
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="mt-6 text-right">
        <button className="bg-[#2C4E86] text-white px-6 py-2 rounded">
          Save
        </button>
      </div>
    </div>
  );
};

export default SalaryAndAssetsCard;
